import { atom } from "jotai";

/**
 * True while the app should show the blocking maintenance-mode overlay
 * (see `MaintenanceModeOverlay.tsx`). Set by `QueryErrorBridge` when a
 * backend call fails with HTTP 503, cleared automatically as soon as any
 * query/mutation on the shared QueryClient succeeds again.
 */
export const maintenanceModeAtom = atom(false);
